export default "__VITE_ASSET__5fXasR58__"